/**
 * FooterButton Component
 * 
 * Floating button that appears at the bottom of the mobile screen
 * to open the footer drawer with additional information and links.
 */

interface FooterButtonProps {
  onClick: () => void;
}

/**
 * FooterButton component
 * Floating button to open footer drawer on mobile
 * 
 * @param props - Component props
 * @param props.onClick - Callback when button is clicked
 * @returns FooterButton component
 */
export function FooterButton({ onClick }: FooterButtonProps) {
  return (
    <button
      onClick={onClick}
      className="footer-button"
      style={{
        position: 'fixed',
        bottom: '1rem',
        left: '50%',
        transform: 'translateX(-50%)',
        background: 'var(--color-surface)',
        color: 'var(--color-accent)',
        border: '2px solid var(--color-accent)',
        borderRadius: '24px',
        padding: '0.75rem 1.5rem',
        fontSize: 'var(--font-size-sm)',
        fontWeight: 'bold',
        fontFamily: 'var(--font-family)',
        cursor: 'pointer',
        zIndex: 100,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.4)',
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        transition: 'all 0.2s ease',
      }}
      onMouseDown={(e) => {
        e.currentTarget.style.transform = 'translateX(-50%) scale(0.95)';
      }}
      onMouseUp={(e) => {
        e.currentTarget.style.transform = 'translateX(-50%) scale(1)';
      }}
      onTouchStart={(e) => {
        e.currentTarget.style.transform = 'translateX(-50%) scale(0.95)';
      }}
      onTouchEnd={(e) => {
        e.currentTarget.style.transform = 'translateX(-50%) scale(1)';
      }}
      aria-label="Open footer information"
    >
      <span aria-hidden="true">ℹ️</span>
      More Info
    </button>
  );
}
